var planets;
var sun,moon,mercury,venus,mars,jupiter,saturn,uranus,neptune,pluto;
var sunT,moonT,mercuryT,venusT,marsT,jupiterT,saturnT,uranusT,neptuneT,plutoT;
var rising;
var risingT;

var desktopNecklace2D = document.getElementById('braceletParent_Desktop')
var mobileNecklace2D = document.getElementById('braceletParent_Mobile')

var desktopNecklace3D = document.getElementById('modelViewD')
var mobileNecklace3D = document.getElementById('modelViewM')

var modelButtonMobile = document.getElementById('ModelButton_M');
var modelButtonDekstop = document.getElementById('ModelButton_D');

var desktop_Parent = document.getElementById('braceletParent_Desktop');
var mobile_Parent = document.getElementById('braceletParent_Mobile');


var desktopBracelet = [];
var mobileBracelet = [];
//-----------------------------------------------------------------------------------

window.onload = (event) =>{
    PaintAllBeidsWhite(); 
}

//-------------

// Function to wait for the objects to render
function waitForRender(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}

// Function to generate dropdown options for days, months, and years
function generateOptions(selectElement, optionsArray) {
  for (let i = 0; i < optionsArray.length; i++) {
    const option = document.createElement("option");
    option.value = optionsArray[i].value; // Set the value of the option
    option.textContent = optionsArray[i].text; // Set the displayed text
    selectElement.appendChild(option);
  }
}

// Function to insert day, month, and year values from 1900 to 2023
function insertDateValues() {
  const currentYear = new Date().getFullYear();

  // Desktop version
  const dayDropdownDesktop = document.getElementById("date_D_D");
  const monthDropdownDesktop = document.getElementById("date_M_D");
  const yearDropdownDesktop = document.getElementById("date_Y_D");

  // Generate options for days (1-31)
  const days = Array.from({ length: 31 }, (_, index) => index + 1);
  generateOptions(dayDropdownDesktop, days.map(day => ({ text: day.toString(), value: day })));

  // Generate options for months with numerical values
  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];
  generateOptions(monthDropdownDesktop, months);

  // Generate options for years (1900-2023)
  const years = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => 1900 + index);
  generateOptions(yearDropdownDesktop, years.map(year => ({ text: year.toString(), value: year })));

  // Set default selected option for year (2000)
  const defaultYear = "2000";
  yearDropdownDesktop.value = defaultYear;

  // Mobile version
  const monthDropdownMobile = document.getElementById("date_M_M");
  const dayDropdownMobile = document.getElementById("date_D_M");
  const yearDropdownMobile = document.getElementById("date_Y_M");

  // Generate options for months with numerical values
  generateOptions(monthDropdownMobile, months);

  // Generate options for days (1-31)
  generateOptions(dayDropdownMobile, days.map(day => ({ text: day.toString(), value: day })));

  // Generate options for years (1900-2023)
  generateOptions(yearDropdownMobile, years.map(year => ({ text: year.toString(), value: year })));

  // Set default selected option for year (2000)
  yearDropdownMobile.value = defaultYear;
}

// Wait for the objects to render and then insert the date values
waitForRender(insertDateValues);

//-------------

const forms = document.querySelectorAll('.formToRemove');

forms.forEach((form) => {
  form.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); 
    }
  });
});



const finishCartElements = document.getElementsByClassName('regular-btn finishCart');

  finishCartElements[0].addEventListener('click', event => {
    event.preventDefault();
    //MOBILE SUBMIT
    MobileSubmit();
    
  });

  finishCartElements[1].addEventListener('click', event => {
    event.preventDefault();
    //DESKTOP SUBMIT
    DesktopSubmit();
    
  });


const MobileSubmit = async() =>{
  console.log('PRESS MOBILE')
  var divToCheck = document.getElementById("backendCheck");
  while(divToCheck.style.backgroundColor != "red"){
    console.log('waiting for red')
    await sleep(500);
  }
   
  
    var shouldInclude = document.querySelector('#includeCheckM input[type="checkbox"]').checked;
    var shouldBracelet = document.querySelector('#braceletCheckM input[type="checkbox"]').checked;

    if(shouldInclude == false && shouldBracelet == false){
       AddToCart(42436849926303);
    }else if(shouldInclude){
       AddToCart(42457071124639);
    }else if(shouldBracelet){
       AddToCart(42459357151391);
    }
}


const DesktopSubmit = async() =>{
  var divToCheck = document.getElementById("backendCheck");
  while(divToCheck.style.backgroundColor != "red"){
    await sleep(500);
  }
   
  
  var shouldInclude = document.querySelector('#includeCheck input[type="checkbox"]').checked;
  var shouldBracelet = document.querySelector('#braceletCheck input[type="checkbox"]').checked;

    if(shouldInclude == false && shouldBracelet == false){
       AddToCart(42436849926303);
    }else if(shouldInclude){
       AddToCart(42457071124639);
    }else if(shouldBracelet){
       AddToCart(42459357151391);
    }
}


function AddToCart(productID){
const quantity = 1;

const url = window.Shopify.routes.root + 'cart/add.js';
const headers = {
  'Content-Type': 'application/json',
};
const data = {
  id: productID,
  quantity: quantity,
};

fetch(url, {
  method: 'POST',
  headers: headers,
  body: JSON.stringify(data),
})
  .then(response => {
    if (response.ok) {
      console.log('Product added to cart');

      switch(productID){
        case 42436849926303:
        window.location.href = 'https://www.shoptenthhouse.com/collections/all';
        break;
        case 42457071124639:
        window.location.href = 'https://www.shoptenthhouse.com/collections/all';
        break;
        case 42459357151391:
        window.location.href = 'https://www.shoptenthhouse.com/collections/all';
        break;          
      }
      
    } else {
      console.log('Error adding product to cart');
    }
  })
  .catch(error => {
    console.log('Error adding product to cart:', error);
  });
}





const switch2 = document.querySelector('#includeCheck input[type="checkbox"]');
const switch3 = document.querySelector('#braceletCheck input[type="checkbox"]');

const switch4 = document.querySelector('#includeCheckM input[type="checkbox"]');
const switch5 = document.querySelector('#braceletCheckM input[type="checkbox"]');

switch2.addEventListener('change', function() {
  if (this.checked) {
    switch3.checked = false;
  }
});

switch3.addEventListener('change', function() {
  if (this.checked) {
    switch2.checked = false;
  }
});
if (switch4 != null){
switch4.addEventListener('change', function() {
  if (this.checked) {
    switch5.checked = false;
  }
});
}
if (switch5 != null){
switch5.addEventListener('change', function() {
  if (this.checked) {
    switch4.checked = false;
  }
});
}


//---------------------------------
//---------------------------------


function ChangeSign(idOfSpan){
  
  var span = document.getElementById(idOfSpan);
  var currClassName = span.className;

  if(document.getElementsByClassName('desktop__version')[0].style.display == 'none'){
  //MOBILE VERSION

  if(span.hasAttribute('tag')){
    //VEC JE NASAO SVOJU GRUPU
    console.log('has tag of ' + span.getAttribute('tag'));
    SortTroughColors(span.getAttribute('tag').replace('_tag',''), span.className, span);
    
  }else{
    //NADJI SVOJU GRUPU
    for(var i=0; i<mobileBracelet.length;i++){
      if(getFirstWord(mobileBracelet[i].className) == getFirstWord(currClassName) && mobileBracelet[i].hasAttribute('isTaken') == false && mobileBracelet[i].hasAttribute('data-center') == false){
        span.setAttribute('tag', mobileBracelet[i].getAttribute('data-group') + '_tag')
        var section = document.querySelectorAll('[data-group="'+mobileBracelet[i].getAttribute('data-group')+'"]');
        section.forEach(element => {
          element.setAttribute('isTaken', true);
        });
        break;
      }
    }

    console.log('found tag of ' + span.getAttribute('tag'));
    SortTroughColors(span.getAttribute('tag').replace('_tag',''), span.className, span);
  }

  }else{
  //DESKTOP VERSION

    if(span.hasAttribute('tag')){
      //VEC JE NASAO SVOJU GRUPU
      console.log('has tag of ' + span.getAttribute('tag'));
      SortTroughColors(span.getAttribute('tag').replace('_tag',''), span.className, span);
      
    }else{
      //NADJI SVOJU GRUPU
      for(var i=0; i<desktopBracelet.length;i++){
        if(getFirstWord(desktopBracelet[i].className) == getFirstWord(currClassName) && desktopBracelet[i].hasAttribute('isTaken') == false && desktopBracelet[i].hasAttribute('data-center') == false){
          span.setAttribute('tag', desktopBracelet[i].getAttribute('data-group') + '_tag')
          var section = document.querySelectorAll('[data-group="'+desktopBracelet[i].getAttribute('data-group')+'"]');
          section.forEach(element => {
            element.setAttribute('isTaken', true);
          });
          break;
        }
      }

      console.log('found tag of ' + span.getAttribute('tag'));
      SortTroughColors(span.getAttribute('tag').replace('_tag',''), span.className, span);
    }

  }
}

function getFirstWord(str) {
  const words = str.split(' ');

  if (words.length < 1) {
    return str;
  }

  return words[0];
}


function SortTroughColors(tagOfSectionToChange,classNameToUse, spanElement){

  const zodiacSigns = [
    'aries fixed',
    'taurus fixed',
    'gemini fixed',
    'cancer fixed',
    'leo fixed',
    'virgo fixed',
    'libra fixed',
    'scorpio fixed',
    'sagittarius fixed',
    'capricorn fixed',
    'aquarius fixed',
    'pisces fixed'
  ];

  if(tagOfSectionToChange == 'groupCenter')
  ConvertSignToIndex(getNextElement(classNameToUse, zodiacSigns));
  else
  Color_DataGroup_Fixed(tagOfSectionToChange, getNextElement(classNameToUse, zodiacSigns))
  spanElement.className = getNextElement(classNameToUse,zodiacSigns);
  spanElement.parentNode.childNodes[2].textContent = ConvertClassNameToString(spanElement.className);

}

function ConvertSignToIndex(className){
  var elements = document.querySelectorAll('[data-center="groupCenter"]');
  var sign = className.split(' ')[0]

  switch (sign) {
    case 'aries':
      Fadded_AriesC(elements);
      break;
    case 'taurus':
      Fadded_TaurusC(elements);
      break;
    case 'gemini':
      Fadded_GeminiC(elements);
      break;
    case 'cancer':
      Fadded_CancerC(elements);
      break;
    case 'leo':
      Fadded_LeoC(elements);
      break;
    case 'virgo':
      Fadded_VirgoC(elements);
      break;
    case 'libra':
      Fadded_LibraC(elements);
      break;
    case 'scorpio':
      Fadded_ScorpioC(elements);
      break;
    case 'sagittarius':
      Fadded_SagittariusC(elements);
      break;
    case 'capricorn':
      Fadded_CapricornC(elements);
      break;
    case 'aquarius':
      Fadded_AquariusC(elements);
      break;
    case 'pisces':
      Fadded_PiscesC(elements);
      break;
  }  

}



function getNextElement(str, arr) {
  const index = arr.indexOf(str);
  if (index === -1) {
    return null;
  }
  if (index === arr.length - 1) {
    return arr[0];
  }
  return arr[index + 1];
}

function ConvertClassNameToString(className){

  var tempVar

  switch(className){
      case 'aries fixed':
          tempVar = 'Aries - Red Agate';
      break;
      case 'taurus fixed':
          tempVar = 'Taurus - Amazonite';
      break;
      case 'gemini fixed':
          tempVar = 'Gemini - Yellow Calcite';
      break;
      case 'cancer fixed':
          tempVar = 'Cancer - Moonstone';
      break;
      case 'leo fixed':
          tempVar = 'Leo - Tigers Eye';
      break;
      case 'virgo fixed':
          tempVar = 'Virgo - Emerald Jade';
      break;
      case 'libra fixed':
          tempVar = 'Libra - Pink Aventurine';
      break;
      case 'scorpio fixed':
          tempVar = 'Scorpio - Lepidolite';
      break;
      case 'sagittarius fixed':
          tempVar = 'Sagittarius - Sunstone';
      break;
      case 'capricorn fixed':
          tempVar = 'Capricorn - Wood Jade';
      break;
      case 'aquarius fixed':
          tempVar = 'Aquarius - Aquamarine';
      break;
      case 'pisces fixed':
          tempVar = 'Pisces - Lavander Amethyst';
      break;
  }

  return tempVar;
}



function ChangePlanet(idOfSpan){
  // var span = document.getElementById(idOfSpan);
  // var currTxt = span.parentNode.parentNode.childNodes[1].innerText;

  // const planets = [
  //   'Rising',
  //   'Moon',
  //   'Mercury',
  //   'Venus',
  //   'Mars',
  //   'Jupiter',
  //   'Saturn',
  //   'Uranus',
  //   'Neptune',
  //   'Pluto'
  // ];

  // span.parentNode.parentNode.childNodes[1].innerText = getNextElement(currTxt, planets);
}

//----------------------------------------------
//----------------------------------------------


function PaintAllBeidsWhite(){
  for (let index = 1; index < desktop_Parent.children.length; index++) {
    desktop_Parent.children[index].className = 'default_white';
    desktopBracelet.push(desktop_Parent.children[index]);
}

for (let index = 1; index < mobile_Parent.children.length; index++) {
    mobile_Parent.children[index].className = 'default_white';
    mobileBracelet.push(mobile_Parent.children[index]);
}
}

function GetNecklace_Structures(){

  desktopBracelet = [];
  mobileBracelet = [];
  
  for (let index = 1; index < desktop_Parent.children.length; index++) 
  desktopBracelet.push(desktop_Parent.children[index]);


for (let index = 1; index < mobile_Parent.children.length; index++) 
  mobileBracelet.push(mobile_Parent.children[index]);

}

function Open3DModel(){

  ChangePatternOfGroup('group1')
  ChangePatternOfGroup('group2')
  ChangePatternOfGroup('group3')
  ChangePatternOfGroup('group4')
  ChangePatternOfGroup('group5')
  Set_Faded_Center(sun);
  ChangePatternOfGroup('group7')
  ChangePatternOfGroup('group8')
  ChangePatternOfGroup('group9')
  ChangePatternOfGroup('group10')
  ChangePatternOfGroup('group11')


  /*
  if(desktopNecklace2D.style.display != 'none'){

    Generate3DNecklace();

    desktopNecklace2D.style.display = 'none'
    mobileNecklace2D.style.display = 'none'

    desktopNecklace3D.style.display = 'block'
    mobileNecklace3D.style.display = 'block'

    modelButtonMobile.style.backgroundImage = "url('2D.png')";
    modelButtonDekstop.style.backgroundImage = "url('2D.png')";

  }else{

    desktopNecklace2D.style.display = ''
    mobileNecklace2D.style.display = ''

    desktopNecklace3D.style.display = 'table-column'
    mobileNecklace3D.style.display = 'table-column'

    modelButtonMobile.style.backgroundImage = "url('{{ '3D.png' | asset_url }}')";
    modelButtonDekstop.style.backgroundImage = "url('{{ '3D.png' | asset_url }}')";

  }*/
}


var mobileTutorial = document.getElementById("mobileTutorial");
var desktopTutorial = document.getElementById("desktopTutorial");

function Show_Hide_Tutorial(){
  
if(mobileTutorial != null){
  if(mobileTutorial.style.display == 'none'){
    //SHOW
    mobileTutorial.style.display = 'block';
         document.getElementById("resultsStepM").classList.add("modal-bg");
    document.body.classList.add("overflow-hidden");
  }else{
    //HIDE
    mobileTutorial.style.display = 'none';
     document.getElementById("resultsStepM").classList.remove("modal-bg");
    document.body.classList.remove("overflow-hidden");
  }
}

if(desktopTutorial != null){
  if(desktopTutorial.style.display == 'none'){
    //SHOW
    desktopTutorial.style.display = 'block';
    //   document.getElementById("resultsStep").classList.add("modal-bg");
    // document.body.classList.add("overflow-hidden");
  }else{
    //HIDE
    desktopTutorial.style.display = 'none';
    //   document.getElementById("resultsStep").classList.remove("modal-bg");
    // document.body.classList.remove("overflow-hidden");
  }
}
}


//------------------------------------------------

function GetUsersDetails(){
    //var fname = document.getElementById("fname_D").value;
    var hbirth = document.getElementById("hbirth_D").value;
    var mbirth = document.getElementById("mbirth_D").value; 

    var date_d = document.getElementById("date_D_D").value; 
    var date_m = document.getElementById("date_M_D").value;
    var date_y = document.getElementById("date_Y_D").value;

    var city = document.getElementById("city_D").value;
    var email = document.getElementById("email_D").value;

    hbirth = ShouldAddZeroBasedOnLength(hbirth) + hbirth.toString();
    mbirth = ShouldAddZeroBasedOnLength(mbirth) + mbirth.toString();

    date_d = ShouldAddZeroBasedOnLength(date_d) + date_d.toString();
    date_m = ShouldAddZeroBasedOnLength(date_m) + date_m.toString();

    console.log("time is " + hbirth + ":" + mbirth);


    var stringDate = date_y.toString() + '-' + date_m.toString() + '-' + date_d.toString() + 'T';
    var stringTime = hbirth.toString() + ':' + mbirth.toString() + ':00';

    console.log("stringTime " + stringTime);

    var lat = document.getElementById('cityList_D').value.toString().split(',')[1];
    var long = document.getElementById('cityList_D').value.toString().split(',')[2];

    //PROVERA INFOA---------------------
    ErrorCheck_Desktop(stringDate,stringTime,lat,long);
}

function ErrorCheck_Desktop(stringDate,stringTime,lat,long){
  var hbirth = document.getElementById("hbirth_D");
  var mbirth = document.getElementById("mbirth_D"); 

  var date_d = document.getElementById("date_D_D"); 
  var date_m = document.getElementById("date_M_D");
  var date_y = document.getElementById("date_Y_D");

  var city = document.getElementById("city_D");
  var email = document.getElementById("email_D");

  var canSubmit = true;

  RedBorderOnEmpty(date_d);
  RedBorderOnEmpty(date_m);
  RedBorderOnEmpty(date_y);

  RedBorderOnEmpty(city);
  RedBorderOnEmpty(email);

  if(date_d.value > 31){
    date_d.style.border = 'solid 1.4px #ff5555'
    canSubmit = false;
  }

  if(date_m.value > 12 || date_m.value == 0){
    date_m.style.border = 'solid 1.4px #ff5555'
    canSubmit = false;
  }

  if(document.getElementById('cityList_D').value == ''){
    document.getElementById('cityList_D').style.border = 'solid 1.4px #ff5555'
    canSubmit = false;
  }else{
    document.getElementById('cityList_D').style.border = ''
  }

  if(email.value.includes("@") == false || email.value.includes(".") == false){
    email.style.border = 'solid 1.4px #ff5555'
    canSubmit = false;
  }


  if((!isInputEmpty(date_d) && !isInputEmpty(date_m) && !isInputEmpty(date_y) && !isInputEmpty(city) && !isInputEmpty(email)) && canSubmit){
    //Progress
    console.log("no error");
    document.getElementById("inputStep").style.display = 'none';
    document.getElementById("resultsStep").style.display = '';
    // FakeLoading();
    // getResults(stringDate,stringTime, lat, long);
    // new api
    var hBirth = hbirth.value;
    var mBirth = mbirth.value; 
    hBirth = ShouldAddZeroBasedOnLength(hBirth) + hBirth.toString();
    mBirth = ShouldAddZeroBasedOnLength(mBirth) + mBirth.toString();
        console.log(hBirth,"hBirth");
    console.log(mBirth,"mBirth");
    
    var dateD = date_d.value; 
    var dateM = date_m.value;
    dateD = ShouldAddZeroBasedOnLength(dateD) + dateD.toString();
    dateM = ShouldAddZeroBasedOnLength(dateM) + dateM.toString();
    var dateY = date_y.value;
    console.log(dateD,"dateD");
    console.log(dateM,"dateM");
    console.log(dateY,"dateY");
    
    var fname = document.getElementById("fname_D").value;  
    var gender = document.querySelector(".gender_D input[name='gender']:checked").value;
    console.log(fname,"fname");
    console.log(gender,"gender");
    var latNum = parseInt(lat);
    var longNum = parseInt(long);
    console.log(latNum,"latNum");
    console.log(longNum,"longNum");
    var cityValue =  city.value;   
    console.log(city,"city");
    console.log(cityValue,"cityValue");
    
    AstroApi(fname,gender,cityValue,dateD,dateM,dateY,hBirth,mBirth,longNum,latNum);
  }
}


function GetUsersDetails_Mobile(){

    var hbirth = document.getElementById("hbirth_M").value;
    var mbirth = document.getElementById("mbirth_M").value; 

    var date_d = document.getElementById("date_D_M").value; 
    var date_m = document.getElementById("date_M_M").value;
    var date_y = document.getElementById("date_Y_M").value;


    hbirth = ShouldAddZeroBasedOnLength(hbirth) + hbirth.toString();
    mbirth = ShouldAddZeroBasedOnLength(mbirth) + mbirth.toString();

    date_d = ShouldAddZeroBasedOnLength(date_d) + date_d.toString();
    date_m = ShouldAddZeroBasedOnLength(date_m) + date_m.toString();

    var stringDate = date_y.toString() + '-' + date_m.toString() + '-' + date_d.toString() + 'T';
    var stringTime = hbirth.toString() + ':' + mbirth.toString() + ':00';

    var lat = document.getElementById('cityList_M').value.toString().split(',')[1];
    var long = document.getElementById('cityList_M').value.toString().split(',')[2];

 
    //PROVERA INFOA---------------------
    Mobile_Step_Check(stringDate,stringTime,lat,long); 
}

function isStepVisible(stepName){
  var elem = document.getElementById(stepName);

  if(elem.style.display != 'none')
  return true;
  else
  return false;
}

function Mobile_Step_Check(stringDate,stringTime,lat,long){
  var fname = document.getElementById("fname_M");
  var hbirth = document.getElementById("hbirth_M");
  var mbirth = document.getElementById("mbirth_M"); 

  var date_d = document.getElementById("date_D_M"); 
  var date_m = document.getElementById("date_M_M");
  var date_y = document.getElementById("date_Y_M");

  var city = document.getElementById("city_M");
  var email = document.getElementById("email_M");

  var quizQty = JSON.parse(localStorage.getItem("QuizData")) || [];
  var quizLength = parseInt(quizQty.length);
  // console.log(quizLength,"quizLength--");
  let productID = '' ;
  for (var i = 0; i < quizQty.length; i++) {
    productID = parseInt(quizQty[i].id);
  }

  if(isStepVisible("stepName")){
    RedBorderOnEmpty(fname);
    if(!isInputEmpty(fname)){
      document.getElementById("stepName").style.display = 'none';
      const sectionQuiz = document.getElementById('product-quiz-new');
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: 'smooth' });
      }
      // console.log(productID,"productID",typeof productID);
      let selectedProduct =  document.querySelector(".product_radio_selected")
      // console.log(selectedProduct,"selectedProduct",typeof selectedProduct);
       let popupBtn = document.querySelector(".discount_popup_Mopener");
       let checkoutBtn = document.querySelector(".last-checkout");
       let idChangeBtn = document.querySelectorAll('.selected-product-id');
      
      if(productID === 44494026866847){
        let inputProduct = document.querySelector('.selected-product-quiz[value="44494026866847"]');
           let selectedID = parseInt(inputProduct.getAttribute('value'));
           let selectedName = inputProduct.getAttribute('data-name');
           let selectedHandle = inputProduct.getAttribute('data-handle');
           // let selectedFprice = inputProduct.getAttribute('data-fprice');
           // let selectedCprice = inputProduct.getAttribute('data-cprice');
          //  let selectedCurrency = inputProduct.getAttribute("data-currency") ;
          // console.log(selectedCurrency,"selectedCurrency--")
        
          idChangeBtn.forEach(function(btnAdd) {
            btnAdd.setAttribute('data-id',selectedID );
            btnAdd.setAttribute('data-name',selectedName );
            btnAdd.setAttribute('data-handle',selectedHandle );
            // btnAdd.setAttribute('data-fprice',selectedFprice );
            // btnAdd.setAttribute('data-cprice',selectedCprice );
            // btnAdd.setAttribute('data-currency',selectedCurrency );
          })

         document.getElementById("stepTime").style.display = 'block';
         selectedProduct.setAttribute('data-selected', productID );
         popupBtn.style.display = 'none' ;
         checkoutBtn.style.display = 'flex' ;
      }
      else{
        document.getElementById("stepProduct").style.display = 'block';
         popupBtn.style.display = 'flex' ;
         checkoutBtn.style.display = 'none' ;
      }
      return;
    }
  }
  if(isStepVisible("stepProduct")){
      let selectedProduct = document.querySelector(".product_radio_selected");
      let getId = selectedProduct.getAttribute('data-selected');
      // console.log(getId,"getId---",typeof getId,getId.length);
     if(getId.length > 0){
        document.getElementById("stepProduct").style.display = 'none';
        const sectionQuiz = document.getElementById('product-quiz-new');
        if (sectionQuiz) {
          sectionQuiz.scrollIntoView({ behavior: 'smooth' });
        }
        document.getElementById("stepTime").style.display = 'block';
       
        let quizIdPendingM = parseInt(localStorage.getItem("PendingQuizM"));
        // console.log(quizIdPendingM,"quizIdPendingM-------",typeof quizIdPendingM);
       
        if(quizIdPendingM > 0){
          window.history.pushState({ page: "another" },"another page","/pages/new-quiz?pendingquiz="+quizIdPendingM+"");
          // window.history.pushState({ page: "another" },"another page","/pages/new-quiz?productId=" + getId + "?pendingquiz="+quizIdPendingM+"");
         }
        else{
          window.history.pushState({ page: "another" },"another page","/pages/new-quiz");
          // window.history.pushState({ page: "another" },"another page","/pages/new-quiz?productId=" + getId + "");
        return;
       }
      }
      else{
        // alert('please select the product');
        let getError = document.querySelector(".product-error");
        getError.style.display = 'block';
        return;
      }
  }

  if(isStepVisible("stepTime")){
    document.getElementById("stepTime").style.display = 'none';
    const sectionQuiz = document.getElementById('product-quiz-new');
    if (sectionQuiz) {
      sectionQuiz.scrollIntoView({ behavior: 'smooth' });
    }
    document.getElementById("stepDate").style.display = 'block';
    return;
  }

  if(isStepVisible("stepDate")){
    RedBorderOnEmpty(date_d);
    RedBorderOnEmpty(date_m);
    RedBorderOnEmpty(date_y);

    if(date_d.value > 31){
      date_d.style.border = 'solid 1.4px #ff5555'
      return;
    }
  
    if(date_m.value > 12 || date_m.value == 0){
      date_m.style.border = 'solid 1.4px #ff5555'
      return;
    }
  
    if(!isInputEmpty(date_d) && !isInputEmpty(date_m) && !isInputEmpty(date_y)){
      document.getElementById("stepDate").style.display = 'none';
      const sectionQuiz = document.getElementById('product-quiz-new');
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: 'smooth' });
      }
      document.getElementById("stepPlace").style.display = 'block';
      return;
    }

  }

  if(isStepVisible("stepPlace")){
    RedBorderOnEmpty(city);

    if(document.getElementById('cityList_M').value == ''){
      document.getElementById('cityList_M').style.border = 'solid 1.4px #ff5555'
      return;
    }
  
    if(!isInputEmpty(city)){
    document.getElementById("stepPlace").style.display = 'none';
     // document.getElementById("stepEmail").style.display = 'block';
      const sectionQuiz = document.getElementById('product-quiz-new');
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: 'smooth' });
      }
    document.getElementById("stepGender").style.display = 'block';
      
    return;
    }
  }

  // new add
  if(isStepVisible("stepGender")){
      document.getElementById("stepGender").style.display = 'none';
       const sectionQuiz = document.getElementById('product-quiz-new');
      if (sectionQuiz) {
        sectionQuiz.scrollIntoView({ behavior: 'smooth' });
      }
      document.getElementById("stepEmail").style.display = 'block';
      let changeText = document.querySelector(".quiz-submit");
      changeText.innerHTML = 'SUBMIT';
      
      return;
      if(!isInputEmpty(gender)){
    }
  }
  // new add ends

  if(isStepVisible("stepEmail")){
    RedBorderOnEmpty(email);

    if(email.value.includes("@") == false || email.value.includes(".") == false){
      email.style.border = 'solid 1.4px #ff5555'
      return;
    }
  
    if(!isInputEmpty(email)){

    // FakeLoading();
    // getResults(stringDate,stringTime, lat, long);
      
    // new add
    var hBirth = hbirth.value;
    var mBirth = mbirth.value; 
    hBirth = ShouldAddZeroBasedOnLength(hBirth) + hBirth.toString();
    mBirth = ShouldAddZeroBasedOnLength(mBirth) + mBirth.toString();
    
    var dateD = date_d.value; 
    var dateM = date_m.value;
    dateD = ShouldAddZeroBasedOnLength(dateD) + dateD.toString();
    dateM = ShouldAddZeroBasedOnLength(dateM) + dateM.toString();
    var dateY = date_y.value;
    console.log(dateD,"dateD---mobile");
    console.log(dateM,"dateM---mobile");
    console.log(dateY,"dateY---mobile");
    
    var fname = fname.value;  
    console.log(fname,"fname---mobile");
    var gender = document.querySelector(".gender_M input[name='genderM']:checked").value;
    console.log(gender,"gender----mobile");
    var latNum = parseInt(lat);
    var longNum = parseInt(long);
    console.log(latNum,"latNum---mobile");
    console.log(longNum,"longNum---mobile");
    var cityValue =  city.value;   
      
    // console.log(city,"city---mobile");
    console.log(cityValue,"cityValue---mobile");
    AstroApi(fname,gender,cityValue,dateD,dateM,dateY,hBirth,mBirth,longNum,latNum);
    // new add ends

    document.getElementById("inputStepM").style.display = 'none';
    const sectionQuiz = document.getElementById('product-quiz-new');
    if (sectionQuiz) {
      sectionQuiz.scrollIntoView({ behavior: 'smooth' });
    }
    document.getElementById("resultsStepM").style.display = '';
    return;
    }
  }
}
// on change of product event
let inputProduct = document.querySelectorAll('.selected-product-quiz');
inputProduct.forEach(function(btn) {
  btn.addEventListener('change', function () {
    let getError = document.querySelector(".product-error");
    getError.style.display = 'none';
    
    let selectedName = btn.getAttribute('data-name');
    let selectedHandle = btn.getAttribute('data-handle');
    // let selectedFprice = btn.getAttribute('data-fprice');
    // let selectedCprice = btn.getAttribute('data-cprice');
    // let selectedCurrency = btn.getAttribute("data-currency") ;
    // console.log(selectedCurrency,"selectedCurrency--")
    
    let selectedID = parseInt(btn.getAttribute('value'));
    let idChange = document.querySelector('.product_radio_selected');
    idChange.setAttribute('data-selected',selectedID );
    
    // window.history.pushState({ page: "another" },"another page","/pages/new-quiz");
    // window.history.pushState({ page: "another" },"another page","/pages/new-quiz?productId=" + selectedID + "");
    // btn to add product in cart
    let idChangeBtn = document.querySelectorAll('.selected-product-id');
    // console.log(idChangeBtn,"idChangeBtn---");
      idChangeBtn.forEach(function(btnAdd) {
        btnAdd.setAttribute('data-id',selectedID );
        btnAdd.setAttribute('data-name',selectedName );
        btnAdd.setAttribute('data-handle',selectedHandle );
        // btnAdd.setAttribute('data-fprice',selectedFprice );
        // btnAdd.setAttribute('data-cprice',selectedCprice );
        // btnAdd.setAttribute('data-currency',selectedCurrency );
    })
    
    let quizIdPendingM = parseInt(localStorage.getItem("PendingQuizM"));
    // console.log(quizIdPendingM,"quizIdPendingM-------",typeof quizIdPendingM);

    if(quizIdPendingM > 0){
      window.history.pushState({ page: "another" },"another page","/pages/new-quiz?pendingquiz="+quizIdPendingM+"");
      // window.history.pushState({ page: "another" },"another page","/pages/new-quiz?productId=" + selectedID + "?pendingquiz="+quizIdPendingM+"");
    }
    else{
      window.history.pushState({ page: "another" },"another page","/pages/new-quiz");
      // window.history.pushState({ page: "another" },"another page","/pages/new-quiz?productId=" + selectedID + "");
    }

    // unhide direct checkout button in product is other than necklase
      // console.log('selectedID',selectedID,typeof selectedID);
      let popupBtn = document.querySelector(".discount_popup_Mopener");
      let checkoutBtn = document.querySelector(".last-checkout");
      if(selectedID !== 44494026866847){
        checkoutBtn.style.display = 'flex' ;
        popupBtn.style.display = 'none' ;
      }
      else {
        checkoutBtn.style.display = 'none' ;
        popupBtn.style.display = 'flex' ;
      }
  })
});

function RedBorderOnEmpty(element){
  if(element.value.length == 0){
    element.style.border = 'solid 1.4px #ff5555'
  }else{
    element.style.border = ''
  }
}

function isInputEmpty(element){
  if(element.value.length == 0)
    return true;
  else
    return false;
}

//----------------------------------------------------

async function getResults(dateToUse, timeToUse, lat, long) {
    console.log('Date is ' + dateToUse);
    console.log('timeToUse is ' + timeToUse);
    console.log('lat is ' + lat);
    console.log('long is ' + long);

    var offsetToUse = await fethTimeZoneOffset(lat, long);
    //converts from CEST to CET
    offsetToUse--;

    console.log("offset is: " + offsetToUse);

    // Handling offset conversion from x.5 to x:30
    if (offsetToUse % 1 !== 0) {
        var wholeOffset = Math.floor(offsetToUse);
        var minutesOffset = "30";
        offsetToUse = (offsetToUse > 0 ? '%2B' : '-') + ShouldAddZeroBasedOnLength(wholeOffset) + wholeOffset.toString() + '%3A' + minutesOffset;
    } else {
        if (offsetToUse > 0) {
            offsetToUse = '%2B' + ShouldAddZeroBasedOnLength(offsetToUse) + offsetToUse.toString() + '%3A00';
        } else {
            offsetToUse = offsetToUse.toString().replace('-', '');
            offsetToUse = '-' + ShouldAddZeroBasedOnLength(offsetToUse) + offsetToUse.toString() + '%3A00';
        }
    }

    // Encode the colons in time as well
    timeToUse = timeToUse.replace(/:/g, '%3A');

    // Combine date, time, and offset
    var isoDateTime = dateToUse + timeToUse + offsetToUse;

    // Construct the URL
    var url = 'https://tent-house-api.onrender.com/horoscope?time=' + isoDateTime + '&latitude=' + lat + '&longitude=' + long + '&houseSystem=P';

    console.log("Sending request with: ");
    console.log("dateToUse: " + dateToUse);
    console.log("timeToUse: " + timeToUse);
    console.log("lat: " + lat);
    console.log("long: " + long);
    console.log("offsetToUse: " + offsetToUse);
    console.log("URL: " + url);

    // Fetch the data
    fetchAsync(url);
}




async function dummyRequest(){
    fetchAsync_dummy('https://tent-house-api.onrender.com/horoscope?time=1111-01-01T11%3A50%3A00-04%3A00&latitude=-33.41167&longitude=-70.66647&houseSystem=P');
}

// Function to handle debouncing of API calls
function debounce(func, delay) {
  let debounceTimer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}

// Add event listeners with debounce
document.getElementById("city_M").addEventListener('input', debounce(doThing, 100));
document.getElementById("city_D").addEventListener('input', debounce(doThing2, 100));


function doThing(){
    getCityOptions(document.getElementById("city_M").value);
        // custom-change input value
    // onchange of city select input value changed
    document.getElementById("cityList_M").addEventListener('focus', function() {
    const valueFinalM =  this.value ;
    const formattedAddressM = valueFinalM.split(',')[0];
    const cityInputM = document.getElementById("city_M");
    cityInputM.value =  formattedAddressM ;
    const cityInput = document.getElementById("city_D");
    cityInput.value =  formattedAddressM ;
       this.style.display = "none";
    // custom-change input value end
  });
}
document.getElementById("cityList_M").addEventListener('focus', function() {
       this.style.display = "none";
  });

function doThing2(){
    getCityOptions(document.getElementById("city_D").value);
  
    // custom-change input value
    // onchange of city select input value changed
  
    document.getElementById("cityList_D").addEventListener('focus', function() {
      const valueFinal =  this.value ;
      const formattedAddress = valueFinal.split(',')[0];
      const cityInput = document.getElementById("city_D");
      cityInput.value =  formattedAddress ;
      const cityInputM = document.getElementById("city_M");
      cityInputM.value =  formattedAddress ;
      this.style.display = "none";
    // custom-change input value end
  }); 
}

document.getElementById("cityList_D").addEventListener('focus', function() {
      this.style.display = "none";
  });

function ShouldAddZeroBasedOnLength(num){ 
    var txt = num.toString();
    if(txt.length < 2)
        return '0';
    else
        return '';
}

let missingCities = [
  { name: "New Jersey", dropdownName: "New Jersey, West, United States", lat: "40.05", long: "-74.40" },
  { name: "Meadowbrook", dropdownName: "Meadowbrook, Queensland, Australia", lat: "-27.6697", long: "153.1696" },
  { name: "Pabianice", dropdownName: "Pabianice, Poland", lat: "51.6642", long: "19.3548" },
  { name: "Gryfino", dropdownName: "Gryfino, West Pomerania, Poland", lat: "53.2521", long: "14.5012" }
];



async function getCityOptions(nameOfCity) {
  const apiKey = 'AIzaSyBmM_hEONyrzZRXBkd7sQq0yWWV121MSgs';
  const geocodingEndpoint = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(nameOfCity)}&key=${apiKey}`;

  try {
    const response = await fetch(geocodingEndpoint);
    const data = await response.json();

    if (data.status === 'OK' && data.results.length > 0) {
      const cityData = data.results[0];
      const formattedAddress = cityData.formatted_address;

      // Ensure that geometry and location exist before accessing latitude and longitude
      if (cityData.geometry && cityData.geometry.location) {
        const lat = cityData.geometry.location.lat;
        const lng = cityData.geometry.location.lng;
        var tempformattedAddress = formattedAddress.replace(/,/g, ' ');

        console.log("AAAAAAAAAAABB: " + tempformattedAddress)

        const optionValue = `${tempformattedAddress},${lat},${lng}`;
        const optionHtml = `<option value="${optionValue}">${tempformattedAddress}</option>`;

        // Set the HTML content for both elements
        const htmlObject = document.getElementById("cityList_M");
        htmlObject.innerHTML = optionHtml;
        htmlObject.style.display = 'block';

        const htmlObjectD = document.getElementById("cityList_D");
        htmlObjectD.innerHTML = optionHtml;
        htmlObjectD.style.display = 'block';
      } else {
        console.log('Latitude and Longitude not found');
      }
    } else {
      console.log('CITY NOT FOUND');
    }
  } catch (error) {
    console.error('Error fetching city data:', error);
  }
}



  async function fethTimeZoneOffset(lat,long) {
    let response = await fetch('https://api.wheretheiss.at/v1/coordinates/'+lat+','+long+'');
    // console.log("Sent time request");

    let data = await response.json();
    var offset = data.offset;

    return offset;
  }

  async function fetchAsync_dummy(url) {
    const sectionQuiz = document.getElementById('product-quiz-new');
    if (sectionQuiz) {
      sectionQuiz.scrollIntoView({ behavior: 'smooth' });
    }
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    let response = await fetch(url);
    console.log("Sent dummy request");

    let data = await response.json();
}

async function fetchAsync(url) {
    let response = await fetch(url);
    console.log("Sent request");

    let data = await response.json();
    console.log(data.data);

    planets = data.data.astros;
    rising = data.data.houses[0].sign;
    console.log("RISING IS " + rising);

    GetPlanetsIndexes();

    return data;
}


  function GetPlanetsIndexes(){

    sun = planets[0].signId + 1;
    moon = planets[1].signId + 1;
    mercury = planets[2].signId + 1;
    venus = planets[3].signId + 1;
    mars = planets[4].signId + 1;
    jupiter = planets[5].signId + 1;
    saturn = planets[6].signId + 1;
    uranus = planets[7].signId + 1;
    neptune = planets[8].signId + 1;
    pluto = planets[9].signId + 1;
    
    // sun = planets.sun.sign;
    // moon = planets.moon.sign;
    // mercury = planets.mercury.sign;
    // venus = planets.venus.sign;
    // mars = planets.mars.sign;
    // jupiter = planets.jupiter.sign;
    // saturn = planets.saturn.sign;
    // uranus = planets.uranus.sign;
    // neptune = planets.neptune.sign;
    // pluto = planets.pluto.sign;

    listOfSings.push(moon,mercury,venus,mars,jupiter,saturn,uranus,neptune,pluto,rising);
    centerStructure = sun;
    // console.log(centerStructure,"centerStructure")

    //Convert to color--------------------
    ConvertResultsToPreviewColors();
    GenerateNecklace();
    //Covert to text--------------------

    risingT = ConvertIndexToSign(rising);

    sunT = ConvertIndexToSign(sun);
    moonT = ConvertIndexToSign(moon);
    mercuryT = ConvertIndexToSign(mercury);
    venusT = ConvertIndexToSign(venus);
    marsT = ConvertIndexToSign(mars);
    jupiterT = ConvertIndexToSign(jupiter);  
    saturnT = ConvertIndexToSign(saturn);
    uranusT = ConvertIndexToSign(uranus);
    neptuneT = ConvertIndexToSign(neptune);
    plutoT = ConvertIndexToSign(pluto);

    ShowResultsIntoDOM();
    ShowResultsIntoDOM_M();
  }

  function ConvertResultsToPreviewColors(){
    document.getElementById("sunCol_M").className = ConvertIndexToColor(sun);
    document.getElementById("risingCol_M").className = ConvertIndexToColor(rising);
    document.getElementById("moonCol_M").className = ConvertIndexToColor(moon);
    document.getElementById("merCol_M").className = ConvertIndexToColor(mercury);
    document.getElementById("venCol_M").className = ConvertIndexToColor(venus);
    document.getElementById("marsCol_M").className = ConvertIndexToColor(mars);
    document.getElementById("jupCol_M").className = ConvertIndexToColor(jupiter);
    document.getElementById("satCol_M").className = ConvertIndexToColor(saturn);
    document.getElementById("uranCol_M").className = ConvertIndexToColor(uranus);
    document.getElementById("neptCol_M").className = ConvertIndexToColor(neptune);
    document.getElementById("plutCol_M").className = ConvertIndexToColor(pluto);

    document.getElementById("sunCol_D").className = ConvertIndexToColor(sun);
    document.getElementById("risingCol_D").className = ConvertIndexToColor(rising);
    document.getElementById("moonCol_D").className = ConvertIndexToColor(moon);
    document.getElementById("merCol_D").className = ConvertIndexToColor(mercury);
    document.getElementById("venCol_D").className = ConvertIndexToColor(venus);
    document.getElementById("marsCol_D").className = ConvertIndexToColor(mars);
    document.getElementById("jupCol_D").className = ConvertIndexToColor(jupiter);
    document.getElementById("satCol_D").className = ConvertIndexToColor(saturn);
    document.getElementById("uranCol_D").className = ConvertIndexToColor(uranus);
    document.getElementById("neptCol_D").className = ConvertIndexToColor(neptune);
    document.getElementById("plutCol_D").className = ConvertIndexToColor(pluto);
  }

//--------------------------------------------
           //left from center
  var necklaceStructureL = [];
          //right from center
  var necklaceStructureR = [];

       //  example: [9, 1, 8, 8, 11, 4, 3, 11, 11, 9, 4]
  var listOfSings = [];
  var centerStructure;
  var darkNums = [10,8,1];

  function GenerateNecklace(){
    Set_Faded_Center(sun);

    console.log(listOfSings);

    //Dark DUPLICATES----------------
    var frequency = {};
    for (let i = 0; i < listOfSings.length; i++) {
    var element = listOfSings[i];
    frequency[element] = (frequency[element] || 0) + 1;
    }

    for (const [key, value] of Object.entries(frequency)) {
    if (value > 1) {
        var numKey = parseInt(key);
    
      if(darkNums.includes(numKey)){
        if(necklaceStructureL[necklaceStructureL.length - 1] !== numKey)
        AddNumL(numKey);

        if(necklaceStructureR[necklaceStructureR.length - 1] !== numKey)
        AddNumR(numKey);
      }
     }
    }   

    //Rest of the Dark--------------
    var shouldL = 0;
    listOfSings.forEach((value, index) => {
    if (value === 10 || value === 8 || value === 1) {
        if(shouldL % 2 == 0){
            AddNumL(value)
            shouldL++;
        }else{
            AddNumR(value)
            shouldL++;
        }
    }
    });

    //Rest duplicates-------------
    var frequency = {};
    for (let i = 0; i < listOfSings.length; i++) {
    var element = listOfSings[i];
    frequency[element] = (frequency[element] || 0) + 1;
    }

    console.log(frequency);

    for (const [key, value] of Object.entries(frequency)) {
    if (value > 1) {
        var numKey = parseInt(key);
        
        if(necklaceStructureL.length == necklaceStructureR.length){
            if(necklaceStructureL[necklaceStructureL.length - 1] !== numKey)
                AddNumL(numKey);
    
            if(necklaceStructureR[necklaceStructureR.length - 1] !== numKey)
                AddNumR(numKey);
        }else{
           //Add one-off to straighten the duplicates
           var firstUniqueValue = findFirstUniqueValue_OrAdditionalDuplicate(listOfSings);

           // console.log("first unique is " + firstUniqueValue);
           
           if(necklaceStructureL.length < necklaceStructureR.length)
            AddNumL(firstUniqueValue);
           else if(necklaceStructureL.length > necklaceStructureR.length)
            AddNumR(firstUniqueValue);

            if(necklaceStructureL[necklaceStructureL.length - 1] !== numKey)
            AddNumL(numKey);
    
            if(necklaceStructureR[necklaceStructureR.length - 1] !== numKey)
            AddNumR(numKey);
        }
     }
    }  
    
    //Rest------------------
    listOfSings.forEach((value, index) => {
          if (necklaceStructureL.length < 5) {
            if (necklaceStructureL[necklaceStructureL.length - 1] !== value) {
                AddNumL(value);
            }
          } else if (necklaceStructureR.length < 5) {
            if (necklaceStructureR[necklaceStructureR.length - 1] !== value) {
                AddNumR(value);
            }
          }
      });
    
    //Rest with duplicates exception---------------
    if(listOfSings.length > 0){
      for(var i=0; i<listOfSings.length;i++){
          if (necklaceStructureL.length < 5) {
              AddNumL(listOfSings[i]);
          } else if (necklaceStructureR.length < 5) {
              AddNumR(listOfSings[i]);
          }

          //zato sto izbaci iz niza kada radi loop
          i--;
      }
    }

    // console.log("left is ")
    // console.log(necklaceStructureL)
    // console.log("-------------------")
    // console.log("right is ")
    // console.log(necklaceStructureR)

    // console.log(listOfSings)

    //Color the left part--------------------
    for(var i=0;i<necklaceStructureL.length;i++){
        Set_Fixed_Left(i,ConvertIndexToColor(necklaceStructureL[i]));
    }

    //Color the right part--------------------
    for(var i=0;i<necklaceStructureR.length;i++){

        Set_Fixed_Right(i,ConvertIndexToColor(necklaceStructureR[i]));
    }
  }

  function Generate3DNecklace(){

    GetNecklace_Structures();

    if(document.getElementsByClassName('desktop__version')[0].style.display != 'none'){

      var modelNecklaceD = document.getElementById('modelViewD');
      for(var i=0; i< modelNecklaceD.model.materials.length-1; i++){
        modelNecklaceD.model.materials[i].pbrMetallicRoughness.setBaseColorFactor(getColor(desktopBracelet[i].className));
      }
      modelNecklaceD.model.materials[modelNecklaceD.model.materials.length-1].pbrMetallicRoughness.setBaseColorFactor("#ffd400");
    }else{

      var modelNecklaceM = document.getElementById('modelViewM');
      for(var i=0; i< modelNecklaceM.model.materials.length-1; i++){
        modelNecklaceM.model.materials[i].pbrMetallicRoughness.setBaseColorFactor(getColor(mobileBracelet[i].className));
      }
      modelNecklaceM.model.materials[modelNecklaceM.model.materials.length-1].pbrMetallicRoughness.setBaseColorFactor("#ffd400");
    }
  }



  function getColor(className) {

    console.log(className)

    var newStr = className.replace(' selected', '');

    console.log(newStr)

    switch (newStr) {
     case 'aries shade__one':
        return '#FF9586';
     case 'aries shade__two':
        return '#F45B46';
     case 'aries fixed':
        return '#FF9586';
     case 'taurus shade__one':
        return '#D4EFDE';
     case 'taurus shade__two':
        return '#B3F4CB';
     case 'taurus shade__three':
        return '#15CDD6';
     case 'taurus fixed':
        return '#B3F4CB';
     case 'gemini fixed':
        return '#F8F79B';
     case 'cancer fixed':
        return '#FFFBFB';
     case 'leo shade__one':
        return '#FFD08A';
     case 'leo fixed':
          return '#FFD08A';
     case 'virgo shade__one':
        return '#DFF6D6';
     case 'virgo shade__two':
        return '#D2E1C2';
     case 'virgo shade__three':
        return '#96BF80';
     case 'virgo fixed':
        return '#D2E1C2';
     case 'libra shade__one':
        return '#FACBDD';
     case 'libra shade__two':
        return '#EF7FAE';
     case 'libra shade__three':
        return '#F68AD4';
     case 'libra shade__four':
        return '#D84A8A';
     case 'libra fixed':
        return '#EF7FAE';
     case 'scorpio shade__one':
        return '#AB7CAD';
     case 'scorpio shade__two':
        return '#755376';
     case 'scorpio fixed':
        return '#AB7CAD';
     case 'sagittarius shade__one':
        return '#FD9F9F';
     case 'sagittarius fixed':
         return '#FD9F9F';
     case 'aquarius shade__one':
        return '#BAFBFF';
     case 'aquarius shade__two':
        return '#9BDCF8';
     case 'aquarius fixed':
        return '#BAFBFF';
     case 'pisces shade__one':
        return '#D3C6F4';
     case 'pisces shade__two':
        return '#A783FF';
     case 'pisces fixed':
        return '#D3C6F4';
     case 'capricorn shade__one':
        return '#EDC7AB';
     case 'capricorn shade__two':
        return '#AB8970';
     case 'capricorn shade__three':
        return '#892C2C';
     case 'capricorn shade__four':
        return '#6D5858';
     case 'capricorn fixed':
        return '#AB8970';
      default:
        return '#000000';
    }
  }


  function AddNumL(num){
    if(necklaceStructureL.length < 5){
        necklaceStructureL.push(num);
        RemoveNumFromList(num);
    }
  }

  function AddNumR(num){
    if(necklaceStructureR.length < 5){
        necklaceStructureR.push(num);
        RemoveNumFromList(num);
    }
  }

  function RemoveNumFromList(num){
    const index = listOfSings.indexOf(num);
    if (index > -1) {
        listOfSings.splice(index, 1);
    }
  }


  //-----------------------------------------------

  function Set_Fixed_Right(index, color){
    switch(index){
        case 0:
            for(var i=0; i< 7;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 1:
            for(var i=7; i< 14;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 2:
            for(var i=14; i< 21;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 3:
            for(var i=21; i< 28;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 4:
            for(var i=28; i< 35;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
    }
  }

  function Set_Fixed_Left(index, color){
    switch(index){
        case 0:
            for(var i=74; i< 81;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 1:
            for(var i=67; i< 74;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 2:
            for(var i=60; i< 67;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 3:
            for(var i=53; i< 60;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
        case 4:
            for(var i=46; i< 53;i++){
                desktopBracelet[i].className = color
                mobileBracelet[i].className = color
            }
        break;
    }
  }

  function Set_Faded_Center(sunIndex){
    ChangePatternOfGroup_Center(sunIndex);
  }

  function ChangePatternOfGroup_Center(sunIndex){
    var elements = document.querySelectorAll('[data-center="groupCenter"]');

    switch(sunIndex) {
        case 1:
          Fadded_AriesC(elements);
          break;
        case 2:
          Fadded_TaurusC(elements);
          break;
        case 3:
          Fadded_GeminiC(elements);
          break;
        case 4:
          Fadded_CancerC(elements);
          break;
        case 5:
          Fadded_LeoC(elements);
          break;
        case 6:
          Fadded_VirgoC(elements);
          break;
        case 7:
          Fadded_LibraC(elements);
          break;
        case 8:
          Fadded_ScorpioC(elements);
          break;
        case 9:
          Fadded_SagittariusC(elements);
          break;
        case 10:
          Fadded_CapricornC(elements);
          break;
        case 11:
          Fadded_AquariusC(elements);
          break;
        case 12:
          Fadded_PiscesC(elements);
          break;
      }
      
  }

  var patternTypes = {
    'group1': 'fixed',
    'group2': 'fixed',
    'group3': 'fixed',
    'group4': 'fixed',
    'group5': 'fixed',
    'group6': 'fixed',
    'group7': 'fixed',
    'group8': 'fixed',
    'group9': 'fixed',
    'group10': 'fixed',
    'group11': 'fixed',
  };

  function SetGroupToShade(groupName){
    console.log(groupName)
    var elements = document.querySelectorAll('[data-group="'+groupName+'"]');
    var currColor = elements[0].className;
    var transformString;

    //0 je ako je mobile
    if(document.getElementsByClassName('desktop__version')[0].style.display == 'none')
    transformString = elements[0].style.transform;
    else
    transformString = elements[7].style.transform;

    const regex = /rotate\((.*?)\)/; 
    const match = transformString.match(regex);
    const rotateValue = match ? match[1] : null;

        //FIXED --> SHADED
        switch(currColor) {
            case 'aries fixed':
              Fadded_Aries(elements, rotateValue);
              break;
            case 'taurus fixed':
              Fadded_Taurus(elements, rotateValue);
              break;
            case 'gemini fixed':
              Fadded_Gemini(elements, rotateValue);
              break;
            case 'cancer fixed':
              Fadded_Cancer(elements, rotateValue);
              break;
            case 'leo fixed':
              Fadded_Leo(elements, rotateValue);
              break;
            case 'virgo fixed':
              Fadded_Virgo(elements, rotateValue);
              break;
            case 'libra fixed':
              Fadded_Libra(elements, rotateValue);
              break;
            case 'scorpio fixed':
              Fadded_Scorpio(elements, rotateValue);
              break;
            case 'sagittarius fixed':
              Fadded_Sagittarius(elements, rotateValue);
              break;
            case 'capricorn fixed':
              Fadded_Capricorn(elements, rotateValue);
              break;
            case 'aquarius fixed':
              Fadded_Aquarius(elements, rotateValue);
              break;
            case 'pisces fixed':
              Fadded_Pisces(elements, rotateValue);
              break;
        }  
    
        patternTypes[groupName] = 'shade';
}
  
  function ChangePatternOfGroup(groupName){
      var elements = document.querySelectorAll('[data-group="'+groupName+'"]');
      var currColor = elements[0].className;
      var transformString;

      //0 je ako je mobile
      if(document.getElementsByClassName('desktop__version')[0].style.display == 'none')
      transformString = elements[0].style.transform;
      else
      transformString = elements[7].style.transform;

      const regex = /rotate\((.*?)\)/; 
      const match = transformString.match(regex);
      const rotateValue = match ? match[1] : null;
  
      if(patternTypes[groupName] === 'fixed'){
          //FIXED --> SHADED
          switch(currColor) {
              case 'aries fixed':
                Fadded_Aries(elements, rotateValue);
                break;
              case 'taurus fixed':
                Fadded_Taurus(elements, rotateValue);
                break;
              case 'gemini fixed':
                Fadded_Gemini(elements, rotateValue);
                break;
              case 'cancer fixed':
                Fadded_Cancer(elements, rotateValue);
                break;
              case 'leo fixed':
                Fadded_Leo(elements, rotateValue);
                break;
              case 'virgo fixed':
                Fadded_Virgo(elements, rotateValue);
                break;
              case 'libra fixed':
                Fadded_Libra(elements, rotateValue);
                break;
              case 'scorpio fixed':
                Fadded_Scorpio(elements, rotateValue);
                break;
              case 'sagittarius fixed':
                Fadded_Sagittarius(elements, rotateValue);
                break;
              case 'capricorn fixed':
                Fadded_Capricorn(elements, rotateValue);
                break;
              case 'aquarius fixed':
                Fadded_Aquarius(elements, rotateValue);
                break;
              case 'pisces fixed':
                Fadded_Pisces(elements, rotateValue);
                break;
          }  
      
          patternTypes[groupName] = 'shade';
      } else {
          //SHADED --> FIXED
          var currColor2 = currColor.split(' ')[0];
      
          switch(currColor2) {
            case 'aries':
              Color_DataGroup_Fixed(groupName, 'aries fixed');
              break;
            case 'taurus':
              Color_DataGroup_Fixed(groupName, 'taurus fixed');
              break;
            case 'gemini':
              Color_DataGroup_Fixed(groupName, 'gemini fixed');
              break;
            case 'cancer':
              Color_DataGroup_Fixed(groupName, 'cancer fixed');
              break;
            case 'leo':
              Color_DataGroup_Fixed(groupName, 'leo fixed');
              break;
            case 'virgo':
              Color_DataGroup_Fixed(groupName, 'virgo fixed');
              break;
            case 'libra':
              Color_DataGroup_Fixed(groupName, 'libra fixed');
              break;
            case 'scorpio':
              Color_DataGroup_Fixed(groupName, 'scorpio fixed');
              break;
            case 'sagittarius':
              Color_DataGroup_Fixed(groupName, 'sagittarius fixed');
              break;
            case 'capricorn':
              Color_DataGroup_Fixed(groupName, 'capricorn fixed');
              break;
            case 'aquarius':
              Color_DataGroup_Fixed(groupName, 'aquarius fixed');
              break;
            case 'pisces':
              Color_DataGroup_Fixed(groupName, 'pisces fixed');
              break;
          }
  
          patternTypes[groupName] = 'fixed';   
      }
  }
  

function Color_DataGroup_Fixed(groupName, colorClass){
    var elements = document.querySelectorAll('[data-group="'+groupName+'"]');

    for(var i=0; i< elements.length; i++){
        elements[i].className = colorClass;
    }
}

function isRightSide(angleString) {
  const angle = parseFloat(angleString.replace("deg", ""));
  return angle >= -84 && angle <= 63.35;
}


function Event_MovedSection(groupName1, groupName2){

  
  var elements1 = document.querySelectorAll('[data-group="'+groupName1+'"]');
  var elements2 = document.querySelectorAll('[data-group="'+groupName2+'"]');
  
  var temp;

  var transformString1;
  //0 je ako je mobile
  if(document.getElementsByClassName('desktop__version')[0].style.display == 'none')
  transformString1 = elements1[0].style.transform;
  else
  transformString1 = elements1[7].style.transform;

  const regex = /rotate\((.*?)\)/; 
  const match = transformString1.match(regex);
  const rotateValue1 = match ? match[1] : null;


  var transformString2;
  //0 je ako je mobile
  if(document.getElementsByClassName('desktop__version')[0].style.display == 'none')
  transformString2 = elements2[0].style.transform;
  else
  transformString2 = elements2[7].style.transform;

  const regex2 = /rotate\((.*?)\)/; 
  const match2 = transformString2.match(regex2);
  const rotateValue2 = match2 ? match2[1] : null;



  if(isRightSide(rotateValue2) == isRightSide(rotateValue1))
  {

    if(document.getElementsByClassName('desktop__version')[0].style.display == 'none'){
      //MOBILE VERSION
      temp = elements1[0].className
      elements1[0].className = elements1[6].className;
      elements1[6].className = temp;
  
      temp = elements1[1].className
      elements1[1].className = elements1[5].className;
      elements1[5].className = temp;
  
      temp = elements1[2].className
      elements1[2].className = elements1[4].className;
      elements1[4].className = temp;
  
  
      temp = elements2[0].className
      elements2[0].className = elements2[6].className;
      elements2[6].className = temp;
  
      temp = elements2[1].className
      elements2[1].className = elements2[5].className;
      elements2[5].className = temp;
  
      temp = elements2[2].className
      elements2[2].className = elements2[4].className;
      elements2[4].className = temp;
    }else{
      //DESKTOP VERSION
      temp = elements1[7].className
      elements1[7].className = elements1[13].className;
      elements1[13].className = temp;
  
      temp = elements1[8].className
      elements1[8].className = elements1[12].className;
      elements1[12].className = temp;
  
      temp = elements1[9].className
      elements1[9].className = elements1[11].className;
      elements1[11].className = temp;
  
  
      temp = elements2[7].className
      elements2[7].className = elements2[13].className;
      elements2[13].className = temp;
  
      temp = elements2[8].className
      elements2[8].className = elements2[12].className;
      elements2[12].className = temp;
  
      temp = elements2[9].className
      elements2[9].className = elements2[11].className;
      elements2[11].className = temp;
    }

  }

}





//FADED----------------------------------
  function Fadded_Capricorn(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
      array[6].className = "capricorn shade__one";
      array[5].className = "capricorn shade__one";
      array[4].className = "capricorn shade__two";
      array[3].className = "capricorn shade__two";
      array[2].className = "capricorn shade__two";
      array[1].className = "capricorn shade__three";
      array[0].className = "capricorn shade__four";
  
      array[13].className = "capricorn shade__one";
      array[12].className = "capricorn shade__one";
      array[11].className = "capricorn shade__two";
      array[10].className = "capricorn shade__two";
      array[9].className = "capricorn shade__two";
      array[8].className = "capricorn shade__three";
      array[7].className = "capricorn shade__four";
    }else{
      array[0].className = "capricorn shade__one";
      array[1].className = "capricorn shade__one";
      array[2].className = "capricorn shade__two";
      array[3].className = "capricorn shade__two";
      array[4].className = "capricorn shade__two";
      array[5].className = "capricorn shade__three";
      array[6].className = "capricorn shade__four";
  
      array[7].className = "capricorn shade__one";
      array[8].className = "capricorn shade__one";
      array[9].className = "capricorn shade__two";
      array[10].className = "capricorn shade__two";
      array[11].className = "capricorn shade__two";
      array[12].className = "capricorn shade__three";
      array[13].className = "capricorn shade__four";
    }

  }

  function Fadded_Virgo(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "virgo shade__one";
    array[5].className = "virgo shade__two";
    array[4].className = "virgo shade__two";
    array[3].className = "virgo shade__two";
    array[2].className = "virgo shade__two";
    array[1].className = "virgo shade__two";
    array[0].className = "virgo shade__three";

    array[13].className = "virgo shade__one";
    array[12].className = "virgo shade__two";
    array[11].className = "virgo shade__two";
    array[10].className = "virgo shade__two";
    array[9].className = "virgo shade__two";
    array[8].className = "virgo shade__two";
    array[7].className = "virgo shade__three";
    }else{
      array[0].className = "virgo shade__one";
      array[1].className = "virgo shade__two";
      array[2].className = "virgo shade__two";
      array[3].className = "virgo shade__two";
      array[4].className = "virgo shade__two";
      array[5].className = "virgo shade__two";
      array[6].className = "virgo shade__three";
  
      array[7].className = "virgo shade__one";
      array[8].className = "virgo shade__two";
      array[9].className = "virgo shade__two";
      array[10].className = "virgo shade__two";
      array[11].className = "virgo shade__two";
      array[12].className = "virgo shade__two";
      array[13].className = "virgo shade__three"; 
    }
  }

  function Fadded_Taurus(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "taurus shade__one";
    array[5].className = "taurus shade__two";
    array[4].className = "taurus shade__two";
    array[3].className = "taurus shade__two";
    array[2].className = "taurus shade__two";
    array[1].className = "taurus shade__three";
    array[0].className = "taurus shade__three";

    array[13].className = "taurus shade__one";
    array[12].className = "taurus shade__two";
    array[11].className = "taurus shade__two";
    array[10].className = "taurus shade__two";
    array[9].className = "taurus shade__two";
    array[8].className = "taurus shade__three";
    array[7].className = "taurus shade__three";
    }else{
      array[0].className = "taurus shade__one";
      array[1].className = "taurus shade__two";
      array[2].className = "taurus shade__two";
      array[3].className = "taurus shade__two";
      array[4].className = "taurus shade__two";
      array[5].className = "taurus shade__three";
      array[6].className = "taurus shade__three";
  
      array[7].className = "taurus shade__one";
      array[8].className = "taurus shade__two";
      array[9].className = "taurus shade__two";
      array[10].className = "taurus shade__two";
      array[11].className = "taurus shade__two";
      array[12].className = "taurus shade__three";
      array[13].className = "taurus shade__three";   
    }
  }

  function Fadded_Pisces(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "pisces shade__one";
    array[5].className = "pisces shade__one";
    array[4].className = "pisces shade__one";
    array[3].className = "pisces shade__one";
    array[2].className = "pisces shade__two";
    array[1].className = "pisces shade__two";
    array[0].className = "pisces shade__two";

    array[13].className = "pisces shade__one";
    array[12].className = "pisces shade__one";
    array[11].className = "pisces shade__one";
    array[10].className = "pisces shade__one";
    array[9].className = "pisces shade__two";
    array[8].className = "pisces shade__two";
    array[7].className = "pisces shade__two";
    }else{
    array[0].className = "pisces shade__one";
    array[1].className = "pisces shade__one";
    array[2].className = "pisces shade__one";
    array[3].className = "pisces shade__one";
    array[4].className = "pisces shade__two";
    array[5].className = "pisces shade__two";
    array[6].className = "pisces shade__two";

    array[7].className = "pisces shade__one";
    array[8].className = "pisces shade__one";
    array[9].className = "pisces shade__one";
    array[10].className = "pisces shade__one";
    array[11].className = "pisces shade__two";
    array[12].className = "pisces shade__two";
    array[13].className = "pisces shade__two";    
    }
  }

  function Fadded_Scorpio(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "scorpio shade__one";
    array[5].className = "scorpio shade__one";
    array[4].className = "scorpio shade__one";
    array[3].className = "scorpio shade__one";
    array[2].className = "scorpio shade__two";
    array[1].className = "scorpio shade__two";
    array[0].className = "scorpio shade__two";

    array[13].className = "scorpio shade__one";
    array[12].className = "scorpio shade__one";
    array[11].className = "scorpio shade__one";
    array[10].className = "scorpio shade__one";
    array[9].className = "scorpio shade__two";
    array[8].className = "scorpio shade__two";
    array[7].className = "scorpio shade__two";
    }else{
      array[0].className = "scorpio shade__one";
      array[1].className = "scorpio shade__one";
      array[2].className = "scorpio shade__one";
      array[3].className = "scorpio shade__one";
      array[4].className = "scorpio shade__two";
      array[5].className = "scorpio shade__two";
      array[6].className = "scorpio shade__two";
  
      array[7].className = "scorpio shade__one";
      array[8].className = "scorpio shade__one";
      array[9].className = "scorpio shade__one";
      array[10].className = "scorpio shade__one";
      array[11].className = "scorpio shade__two";
      array[12].className = "scorpio shade__two";
      array[13].className = "scorpio shade__two";   
    }
  }

  function Fadded_Cancer(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "cancer fixed";
    array[5].className = "cancer fixed";
    array[4].className = "cancer fixed";
    array[3].className = "cancer fixed";
    array[2].className = "cancer fixed";
    array[1].className = "cancer fixed";
    array[0].className = "cancer fixed";

    array[13].className = "cancer fixed";
    array[12].className = "cancer fixed";
    array[11].className = "cancer fixed";
    array[10].className = "cancer fixed";
    array[9].className = "cancer fixed";
    array[8].className = "cancer fixed";
    array[7].className = "cancer fixed";
    }else{
      array[0].className = "cancer fixed";
      array[1].className = "cancer fixed";
      array[2].className = "cancer fixed";
      array[3].className = "cancer fixed";
      array[4].className = "cancer fixed";
      array[5].className = "cancer fixed";
      array[6].className = "cancer fixed";
  
      array[7].className = "cancer fixed";
      array[8].className = "cancer fixed";
      array[9].className = "cancer fixed";
      array[10].className = "cancer fixed";
      array[11].className = "cancer fixed";
      array[12].className = "cancer fixed";   
      array[13].className = "cancer fixed"; 
    }
  }

  function Fadded_Libra(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "libra shade__one";
    array[5].className = "libra shade__two";
    array[4].className = "libra shade__two";
    array[3].className = "libra shade__two";
    array[2].className = "libra shade__three";
    array[1].className = "libra shade__three";
    array[0].className = "libra shade__four";

    array[13].className = "libra shade__one";
    array[12].className = "libra shade__two";
    array[11].className = "libra shade__two";
    array[10].className = "libra shade__two";
    array[9].className = "libra shade__three";
    array[8].className = "libra shade__three";
    array[7].className = "libra shade__four";
    }else{
      array[0].className = "libra shade__one";
      array[1].className = "libra shade__two";
      array[2].className = "libra shade__two";
      array[3].className = "libra shade__two";
      array[4].className = "libra shade__three";
      array[5].className = "libra shade__three";
      array[6].className = "libra shade__four";
  
      array[7].className = "libra shade__one";
      array[8].className = "libra shade__two";
      array[9].className = "libra shade__two";
      array[10].className = "libra shade__two";
      array[11].className = "libra shade__three";
      array[12].className = "libra shade__three";
      array[13].className = "libra shade__four";   
    }
  }
  
  function Fadded_Gemini(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "gemini fixed";
    array[5].className = "gemini fixed";
    array[4].className = "gemini fixed";
    array[3].className = "gemini fixed";
    array[2].className = "gemini fixed";
    array[1].className = "gemini fixed";
    array[0].className = "gemini fixed";

    array[13].className = "gemini fixed";
    array[12].className = "gemini fixed";
    array[11].className = "gemini fixed";
    array[10].className = "gemini fixed";
    array[9].className = "gemini fixed";
    array[8].className = "gemini fixed";
    array[7].className = "gemini fixed";
    }else{
      array[0].className = "gemini fixed";
    array[1].className = "gemini fixed";
    array[2].className = "gemini fixed";
    array[3].className = "gemini fixed";
    array[4].className = "gemini fixed";
    array[5].className = "gemini fixed";
    array[6].className = "gemini fixed";

    array[7].className = "gemini fixed";
    array[8].className = "gemini fixed";
    array[9].className = "gemini fixed";
    array[10].className = "gemini fixed";
    array[11].className = "gemini fixed";
    array[12].className = "gemini fixed";
    array[13].className = "gemini fixed";    
    }
  }
  
  function Fadded_Aquarius(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "aquarius shade__one";
    array[5].className = "aquarius shade__one";
    array[4].className = "aquarius shade__one";
    array[3].className = "aquarius shade__one";
    array[2].className = "aquarius shade__two";
    array[1].className = "aquarius shade__two";
    array[0].className = "aquarius shade__two";

    array[13].className = "aquarius shade__one";
    array[12].className = "aquarius shade__one";
    array[11].className = "aquarius shade__one";
    array[10].className = "aquarius shade__one";
    array[9].className = "aquarius shade__two";
    array[8].className = "aquarius shade__two";
    array[7].className = "aquarius shade__two";
    }else{
      array[0].className = "aquarius shade__one";
      array[1].className = "aquarius shade__one";
      array[2].className = "aquarius shade__one";
      array[3].className = "aquarius shade__one";
      array[4].className = "aquarius shade__two";
      array[5].className = "aquarius shade__two";
      array[6].className = "aquarius shade__two";
  
      array[7].className = "aquarius shade__one";
      array[8].className = "aquarius shade__one";
      array[9].className = "aquarius shade__one";
      array[10].className = "aquarius shade__one";
      array[11].className = "aquarius shade__two";
      array[12].className = "aquarius shade__two";
      array[13].className = "aquarius shade__two";     
    }
  }
  
  function Fadded_Sagittarius(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "sagittarius shade__one";
    array[5].className = "sagittarius shade__one";
    array[4].className = "sagittarius shade__one";
    array[3].className = "sagittarius shade__one";
    array[2].className = "sagittarius shade__one";
    array[1].className = "sagittarius shade__one";
    array[0].className = "sagittarius shade__one";

    array[13].className = "sagittarius shade__one";
    array[12].className = "sagittarius shade__one";
    array[11].className = "sagittarius shade__one";
    array[10].className = "sagittarius shade__one";
    array[9].className = "sagittarius shade__one";
    array[8].className = "sagittarius shade__one";
    array[7].className = "sagittarius shade__one";
    }else{
      array[0].className = "sagittarius shade__one";
      array[1].className = "sagittarius shade__one";
      array[2].className = "sagittarius shade__one";
      array[3].className = "sagittarius shade__one";
      array[4].className = "sagittarius shade__one";
      array[5].className = "sagittarius shade__one";
      array[6].className = "sagittarius shade__one";
  
      array[7].className = "sagittarius shade__one";
      array[8].className = "sagittarius shade__one";
      array[9].className = "sagittarius shade__one";
      array[10].className = "sagittarius shade__one";
      array[11].className = "sagittarius shade__one";
      array[12].className = "sagittarius shade__one";
      array[13].className = "sagittarius shade__one";     
    }
  }

  function Fadded_Aries(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "aries shade__one";
    array[5].className = "aries shade__one";
    array[4].className = "aries shade__one";
    array[3].className = "aries shade__one";
    array[2].className = "aries shade__two";
    array[1].className = "aries shade__two";
    array[0].className = "aries shade__two";

    array[13].className = "aries shade__one";
    array[12].className = "aries shade__one";
    array[11].className = "aries shade__one";
    array[10].className = "aries shade__one";
    array[9].className = "aries shade__two";
    array[8].className = "aries shade__two";
    array[7].className = "aries shade__two";
    }else{
      array[0].className = "aries shade__one";
      array[1].className = "aries shade__one";
      array[2].className = "aries shade__one";
      array[3].className = "aries shade__one";
      array[4].className = "aries shade__two";
      array[5].className = "aries shade__two";
      array[6].className = "aries shade__two";
  
      array[7].className = "aries shade__one";
      array[8].className = "aries shade__one";
      array[9].className = "aries shade__one";
      array[10].className = "aries shade__one";
      array[11].className = "aries shade__two";
      array[12].className = "aries shade__two";
      array[13].className = "aries shade__two";  
    }
  }

  function Fadded_Leo(array, groupNameToUse){
    if(isRightSide(groupNameToUse)){
    array[6].className = "leo shade__one";
    array[5].className = "leo shade__one";
    array[4].className = "leo shade__one";
    array[3].className = "leo shade__one";
    array[2].className = "leo shade__one";
    array[1].className = "leo shade__one";
    array[0].className = "leo shade__one";

    array[13].className = "leo shade__one";
    array[12].className = "leo shade__one";
    array[11].className = "leo shade__one";
    array[10].className = "leo shade__one";
    array[9].className = "leo shade__one";
    array[8].className = "leo shade__one";
    array[7].className = "leo shade__one";
    }else{
      array[0].className = "leo shade__one";
    array[1].className = "leo shade__one";
    array[2].className = "leo shade__one";
    array[3].className = "leo shade__one";
    array[4].className = "leo shade__one";
    array[5].className = "leo shade__one";
    array[6].className = "leo shade__one";

    array[7].className = "leo shade__one";
    array[8].className = "leo shade__one";
    array[9].className = "leo shade__one";
    array[10].className = "leo shade__one";
    array[11].className = "leo shade__one";
    array[12].className = "leo shade__one";
    array[13].className = "leo shade__one";    
    }
  }


//FADED----------------------------------


//FADED center----------------------------------
  function Fadded_CapricornC(array){
    array[0].className = "capricorn shade__four";
    array[1].className = "capricorn shade__four";
    array[2].className = "capricorn shade__three";
    array[3].className = "capricorn shade__two";
    array[4].className = "capricorn shade__two";
    array[5].className = "capricorn shade__one";
    array[6].className = "capricorn shade__two";
    array[7].className = "capricorn shade__two";
    array[8].className = "capricorn shade__three";
    array[9].className = "capricorn shade__four";
    array[10].className = "capricorn shade__four";

    array[11].className = "capricorn shade__four";
    array[12].className = "capricorn shade__four";
    array[13].className = "capricorn shade__three";
    array[14].className = "capricorn shade__two";
    array[15].className = "capricorn shade__two";
    array[16].className = "capricorn shade__one";
    array[17].className = "capricorn shade__two";
    array[18].className = "capricorn shade__two";
    array[19].className = "capricorn shade__three";
    array[20].className = "capricorn shade__four";
    array[21].className = "capricorn shade__four";
  }

  function Fadded_VirgoC(array){
    array[0].className = "virgo shade__three";
    array[1].className = "virgo shade__two";
    array[2].className = "virgo shade__two";
    array[3].className = "virgo shade__two";
    array[4].className = "virgo shade__two";
    array[5].className = "virgo shade__one";
    array[6].className = "virgo shade__two";
    array[7].className = "virgo shade__two";
    array[8].className = "virgo shade__two";
    array[9].className = "virgo shade__two";
    array[10].className = "virgo shade__three";
    
    array[11].className = "virgo shade__three";
    array[12].className = "virgo shade__two";
    array[13].className = "virgo shade__two";
    array[14].className = "virgo shade__two";
    array[15].className = "virgo shade__two";
    array[16].className = "virgo shade__one";
    array[17].className = "virgo shade__two";
    array[18].className = "virgo shade__two";
    array[19].className = "virgo shade__two";
    array[20].className = "virgo shade__two";
    array[21].className = "virgo shade__three";
  }

  function Fadded_TaurusC(array){
    array[0].className = "taurus shade__three";
    array[1].className = "taurus shade__three";
    array[2].className = "taurus shade__two";
    array[3].className = "taurus shade__two";
    array[4].className = "taurus shade__two";
    array[5].className = "taurus shade__one";
    array[6].className = "taurus shade__two";
    array[7].className = "taurus shade__two";
    array[8].className = "taurus shade__two";
    array[9].className = "taurus shade__three";
    array[10].className = "taurus shade__three";
    
    array[11].className = "taurus shade__three";
    array[12].className = "taurus shade__three";
    array[13].className = "taurus shade__two";
    array[14].className = "taurus shade__two";
    array[15].className = "taurus shade__two";
    array[16].className = "taurus shade__one";
    array[17].className = "taurus shade__two";
    array[18].className = "taurus shade__two";
    array[19].className = "taurus shade__two";
    array[20].className = "taurus shade__three";
    array[21].className = "taurus shade__three";
  }

  function Fadded_PiscesC(array){
    array[0].className = "pisces shade__two";
    array[1].className = "pisces shade__two";
    array[2].className = "pisces shade__two";
    array[3].className = "pisces shade__one";
    array[4].className = "pisces shade__one";
    array[5].className = "pisces shade__one";
    array[6].className = "pisces shade__one";
    array[7].className = "pisces shade__one";
    array[8].className = "pisces shade__two";
    array[9].className = "pisces shade__two";
    array[10].className = "pisces shade__two";
    
    array[11].className = "pisces shade__two";
    array[12].className = "pisces shade__two";
    array[13].className = "pisces shade__two";
    array[14].className = "pisces shade__one";
    array[15].className = "pisces shade__one";
    array[16].className = "pisces shade__one";
    array[17].className = "pisces shade__one";
    array[18].className = "pisces shade__one";
    array[19].className = "pisces shade__two";
    array[20].className = "pisces shade__two";
    array[21].className = "pisces shade__two";
  }

  function Fadded_ScorpioC(array){
    array[0].className = "scorpio shade__two";
    array[1].className = "scorpio shade__two";
    array[2].className = "scorpio shade__two";
    array[3].className = "scorpio shade__one";
    array[4].className = "scorpio shade__one";
    array[5].className = "scorpio shade__one";
    array[6].className = "scorpio shade__one";
    array[7].className = "scorpio shade__one";
    array[8].className = "scorpio shade__two";
    array[9].className = "scorpio shade__two";
    array[10].className = "scorpio shade__two";
    
    array[11].className = "scorpio shade__two";
    array[12].className = "scorpio shade__two";
    array[13].className = "scorpio shade__two";
    array[14].className = "scorpio shade__one";
    array[15].className = "scorpio shade__one";
    array[16].className = "scorpio shade__one";
    array[17].className = "scorpio shade__one";
    array[18].className = "scorpio shade__one";
    array[19].className = "scorpio shade__two";
    array[20].className = "scorpio shade__two";
    array[21].className = "scorpio shade__two";
  }

  function Fadded_CancerC(array){
    array[0].className = "cancer fixed";
    array[1].className = "cancer fixed";
    array[2].className = "cancer fixed";
    array[3].className = "cancer fixed";
    array[4].className = "cancer fixed";
    array[5].className = "cancer fixed";
    array[6].className = "cancer fixed";
    array[7].className = "cancer fixed";
    array[8].className = "cancer fixed";
    array[9].className = "cancer fixed";
    array[10].className = "cancer fixed";
    
    array[11].className = "cancer fixed";
    array[12].className = "cancer fixed";
    array[13].className = "cancer fixed";
    array[14].className = "cancer fixed";
    array[15].className = "cancer fixed";
    array[16].className = "cancer fixed";
    array[17].className = "cancer fixed";
    array[18].className = "cancer fixed";
    array[19].className = "cancer fixed";
    array[20].className = "cancer fixed";
    array[21].className = "cancer fixed";
  }

  function Fadded_LibraC(array){
    array[0].className = "libra shade__four";
    array[1].className = "libra shade__four";
    array[2].className = "libra shade__two";
    array[3].className = "libra shade__two";
    array[4].className = "libra shade__one";
    array[5].className = "libra shade__one";
    array[6].className = "libra shade__one";
    array[7].className = "libra shade__two";
    array[8].className = "libra shade__two";
    array[9].className = "libra shade__four";
    array[10].className = "libra shade__four";
    
    array[11].className = "libra shade__four";
    array[12].className = "libra shade__four";
    array[13].className = "libra shade__two";
    array[14].className = "libra shade__two";
    array[15].className = "libra shade__one";
    array[16].className = "libra shade__one";
    array[17].className = "libra shade__one";
    array[18].className = "libra shade__two";
    array[19].className = "libra shade__two";
    array[20].className = "libra shade__four";
    array[21].className = "libra shade__four";
  }
  
  function Fadded_GeminiC(array){
    array[0].className = "gemini fixed";
    array[1].className = "gemini fixed";
    array[2].className = "gemini fixed";
    array[3].className = "gemini fixed";
    array[4].className = "gemini fixed";
    array[5].className = "gemini fixed";
    array[6].className = "gemini fixed";
    array[7].className = "gemini fixed";
    array[8].className = "gemini fixed";
    array[9].className = "gemini fixed";
    array[10].className = "gemini fixed";
    
    array[11].className = "gemini fixed";
    array[12].className = "gemini fixed";
    array[13].className = "gemini fixed";
    array[14].className = "gemini fixed";
    array[15].className = "gemini fixed";
    array[16].className = "gemini fixed";
    array[17].className = "gemini fixed";
    array[18].className = "gemini fixed";
    array[19].className = "gemini fixed";
    array[20].className = "gemini fixed";
    array[21].className = "gemini fixed";
  }
  
  function Fadded_AquariusC(array){
    array[0].className = "aquarius shade__two";
    array[1].className = "aquarius shade__two";
    array[2].className = "aquarius shade__two";
    array[3].className = "aquarius shade__one";
    array[4].className = "aquarius shade__one";
    array[5].className = "aquarius shade__one";
    array[6].className = "aquarius shade__one";
    array[7].className = "aquarius shade__one";
    array[8].className = "aquarius shade__two";
    array[9].className = "aquarius shade__two";
    array[10].className = "aquarius shade__two";
    
    array[11].className = "aquarius shade__two";
    array[12].className = "aquarius shade__two";
    array[13].className = "aquarius shade__two";
    array[14].className = "aquarius shade__one";
    array[15].className = "aquarius shade__one";
    array[16].className = "aquarius shade__one";
    array[17].className = "aquarius shade__one";
    array[18].className = "aquarius shade__one";
    array[19].className = "aquarius shade__two";
    array[20].className = "aquarius shade__two";
    array[21].className = "aquarius shade__two";
  }
  
  function Fadded_SagittariusC(array){
    array[0].className = "sagittarius shade__one";
    array[1].className = "sagittarius shade__one";
    array[2].className = "sagittarius shade__one";
    array[3].className = "sagittarius shade__one";
    array[4].className = "sagittarius shade__one";
    array[5].className = "sagittarius shade__one";
    array[6].className = "sagittarius shade__one";
    array[7].className = "sagittarius shade__one";
    array[8].className = "sagittarius shade__one";
    array[9].className = "sagittarius shade__one";
    array[10].className = "sagittarius shade__one";
    
    array[11].className = "sagittarius shade__one";
    array[12].className = "sagittarius shade__one";
    array[13].className = "sagittarius shade__one";
    array[14].className = "sagittarius shade__one";
    array[15].className = "sagittarius shade__one";
    array[16].className = "sagittarius shade__one";
    array[17].className = "sagittarius shade__one";
    array[18].className = "sagittarius shade__one";
    array[19].className = "sagittarius shade__one";
    array[20].className = "sagittarius shade__one";
    array[21].className = "sagittarius shade__one";
  }

  function Fadded_AriesC(array){
    array[0].className = "aries shade__two";
    array[1].className = "aries shade__two";
    array[2].className = "aries shade__two";
    array[3].className = "aries shade__one";
    array[4].className = "aries shade__one";
    array[5].className = "aries shade__one";
    array[6].className = "aries shade__one";
    array[7].className = "aries shade__one";
    array[8].className = "aries shade__two";
    array[9].className = "aries shade__two";
    array[10].className = "aries shade__two";
    
    array[11].className = "aries shade__two";
    array[12].className = "aries shade__two";
    array[13].className = "aries shade__two";
    array[14].className = "aries shade__one";
    array[15].className = "aries shade__one";
    array[16].className = "aries shade__one";
    array[17].className = "aries shade__one";
    array[18].className = "aries shade__one";
    array[19].className = "aries shade__two";
    array[20].className = "aries shade__two";
    array[21].className = "aries shade__two";
  }

  function Fadded_LeoC(array){
    array[0].className = "leo shade__one";
    array[1].className = "leo shade__one";
    array[2].className = "leo shade__one";
    array[3].className = "leo shade__one";
    array[4].className = "leo shade__one";
    array[5].className = "leo shade__one";
    array[6].className = "leo shade__one";
    array[7].className = "leo shade__one";
    array[8].className = "leo shade__one";
    array[9].className = "leo shade__one";
    array[10].className = "leo shade__one";
    
    array[11].className = "leo shade__one";
    array[12].className = "leo shade__one";
    array[13].className = "leo shade__one";
    array[14].className = "leo shade__one";
    array[15].className = "leo shade__one";
    array[16].className = "leo shade__one";
    array[17].className = "leo shade__one";
    array[18].className = "leo shade__one";
    array[19].className = "leo shade__one";
    array[20].className = "leo shade__one";
    array[21].className = "leo shade__one";
  }
//FADED center----------------------------------






  function findFirstUniqueValue_OrAdditionalDuplicate(arr) {
    let uniqueValues = {};
    
    for (let i = 0; i < arr.length; i++) {
      if (uniqueValues[arr[i]] === undefined) {
        uniqueValues[arr[i]] = 1;
      } else {
        uniqueValues[arr[i]]++;
      }
    }
    
    for (let i = 0; i < arr.length; i++) {
      if (uniqueValues[arr[i]] === 1) {
        return arr[i];
      }
    }


    //It didn't return --> return an odd duplicate
    var frequency = {};
    for (let i = 0; i < listOfSings.length; i++) {
    var element = listOfSings[i];
    frequency[element] = (frequency[element] || 0) + 1;
    }

    for (const [key, value] of Object.entries(frequency)) {
    if (value > 2) {
        var numKey = parseInt(key);
        return numKey;
      }
    }  
  }
  

//--------------------------------------------

  function ConvertIndexToSign(variable){

    var tempVar

    switch(variable){
        case 1:
            tempVar = 'Aries - Red Agate';
        break;
        case 2:
            tempVar = 'Taurus - Amazonite';
        break;
        case 3:
            tempVar = 'Gemini - Yellow Calcite';
        break;
        case 4:
            tempVar = 'Cancer - Moonstone';
        break;
        case 5:
            tempVar = 'Leo - Tigers Eye';
        break;
        case 6:
            tempVar = 'Virgo - Emerald Jade';
        break;
        case 7:
            tempVar = 'Libra - Pink Aventurine';
        break;
        case 8:
            tempVar = 'Scorpio - Lepidolite';
        break;
        case 9:
            tempVar = 'Sagittarius - Sunstone';
        break;
        case 10:
            tempVar = 'Capricorn - Wood Jade';
        break;
        case 11:
            tempVar = 'Aquarius - Aquamarine';
        break;
        case 12:
            tempVar = 'Pisces - Lavander Amethyst';
        break;
    }

    return tempVar;
  }

  function ConvertIndexToColor(variable){
    
    var tempVar

    switch(variable){
        case 1:
            tempVar = 'aries fixed';
        break;
        case 2:
            tempVar = 'taurus fixed';
        break;
        case 3:
            tempVar = 'gemini fixed';
        break;
        case 4:
            tempVar = 'cancer fixed';
        break;
        case 5:
            tempVar = 'leo fixed';
        break;
        case 6:
            tempVar = 'virgo fixed';
        break;
        case 7:
            tempVar = 'libra fixed';
        break;
        case 8:
            tempVar = 'scorpio fixed';
        break;
        case 9:
            tempVar = 'sagittarius fixed';
        break;
        case 10:
            tempVar = 'capricorn fixed';
        break;
        case 11:
            tempVar = 'aquarius fixed';
        break;
        case 12:
            tempVar = 'pisces fixed';
        break;
    }

    return tempVar;
  }



  const ShowResultsIntoDOM_M = async() =>{

    var risingTxt = document.getElementById('risingTxt2');
    var sunTxt = document.getElementById('sunTxt2');

    var moonTxt = document.getElementById('moonTxt2');
    var mercTxt = document.getElementById('mercuryTxt2');
    var venusTxt = document.getElementById('venusTxt2');
    var marsTxt = document.getElementById('marsTxt2');
    var jupTxt = document.getElementById('jupiterTxt2');
    var satTxt = document.getElementById('saturnTxt2');
    var uranusTxt = document.getElementById('uranusTxt2');
    var nepTxt = document.getElementById('neptuneTxt2');
    var plutoTxt = document.getElementById('plutoTxt2');

    risingTxt.childNodes[2].textContent = risingT;
    sunTxt.childNodes[2].textContent = sunT;
    moonTxt.childNodes[2].textContent = moonT;
    mercTxt.childNodes[2].textContent = mercuryT;
    venusTxt.childNodes[2].textContent = venusT;
    marsTxt.childNodes[2].textContent = marsT;
    jupTxt.childNodes[2].textContent = jupiterT;
    satTxt.childNodes[2].textContent = saturnT;
    uranusTxt.childNodes[2].textContent = uranusT;
    nepTxt.childNodes[2].textContent = neptuneT;
    plutoTxt.childNodes[2].textContent = plutoT;
    
    // risingTxt.childNodes[1].textContent = risingT;
    // sunTxt.childNodes[1].textContent = sunT;
    // moonTxt.childNodes[1].textContent = moonT;
    // mercTxt.childNodes[1].textContent = mercuryT;
    // venusTxt.childNodes[1].textContent = venusT;
    // marsTxt.childNodes[1].textContent = marsT;
    // jupTxt.childNodes[1].textContent = jupiterT;
    // satTxt.childNodes[1].textContent = saturnT;
    // uranusTxt.childNodes[1].textContent = uranusT;
    // nepTxt.childNodes[1].textContent = neptuneT;
    // plutoTxt.childNodes[1].textContent = plutoT;

    completeLoading();

    await sleep(1500)

    TurnOnPage_M();
  }

  const ShowResultsIntoDOM = async() =>{

    var risingTxt = document.getElementById('risingTxt');
    var sunTxt = document.getElementById('sunTxt');

    var moonTxt = document.getElementById('moonTxt');
    var mercTxt = document.getElementById('mercuryTxt');
    var venusTxt = document.getElementById('venusTxt');
    var marsTxt = document.getElementById('marsTxt');
    var jupTxt = document.getElementById('jupiterTxt');
    var satTxt = document.getElementById('saturnTxt');
    var uranusTxt = document.getElementById('uranusTxt');
    var nepTxt = document.getElementById('neptuneTxt');
    var plutoTxt = document.getElementById('plutoTxt');

    risingTxt.childNodes[2].textContent = risingT;
    sunTxt.childNodes[2].textContent = sunT;

    moonTxt.childNodes[2].textContent = moonT;
    mercTxt.childNodes[2].textContent = mercuryT;
    venusTxt.childNodes[2].textContent = venusT;
    marsTxt.childNodes[2].textContent = marsT;
    jupTxt.childNodes[2].textContent = jupiterT;
    satTxt.childNodes[2].textContent = saturnT;
    uranusTxt.childNodes[2].textContent = uranusT;
    nepTxt.childNodes[2].textContent = neptuneT;
    plutoTxt.childNodes[2].textContent = plutoT;
    
    // sunTxt.childNodes[2].textContent = sunT;
    // console.log(sunTxt.childNodes,"sunTxt.childNodes[1].textContent-----------check");
    // console.log(sunTxt,"sunTxt.textContent");
    // console.log(sunT,"sunT");
    // risingTxt.childNodes[1].textContent = risingT;
    // sunTxt.childNodes[1].textContent = sunT;

    // moonTxt.childNodes[1].textContent = moonT;
    // mercTxt.childNodes[1].textContent = mercuryT;
    // venusTxt.childNodes[1].textContent = venusT;
    // marsTxt.childNodes[1].textContent = marsT;
    // jupTxt.childNodes[1].textContent = jupiterT;
    // satTxt.childNodes[1].textContent = saturnT;
    // uranusTxt.childNodes[1].textContent = uranusT;
    // nepTxt.childNodes[1].textContent = neptuneT;
    // plutoTxt.childNodes[1].textContent = plutoT;

    completeLoading();
    
    await sleep(1500)

    TurnOnPage();
  }



  const TurnOnPage = async()=>{
    document.getElementById('resultsPage').style.display = 'flex';
    document.getElementById('waitingTxt').style.display = 'none';

    // await sleep(1500);
    window.scrollTo({ top: 0, behavior: 'smooth' });
     document.getElementById("resultsStep").classList.add("modal-bg");
    document.body.classList.add("overflow-hidden");
    
    if(desktopTutorial != null){
        desktopTutorial.style.opacity = 1;
      }
  }

  const TurnOnPage_M = async()=>{
    // document.getElementById('resultsPage_M').style.display = 'flex';
    // document.getElementById('resultsPage_M').style.height = 'auto';
    document.getElementById('resultsPage_M').style.opacity = '1';
    document.getElementById('resultsPage_M').style.position = 'static';
    
         var fname =   document.getElementById("fname_M");
      var fnameVal = fname.value;  
    let resultText = document.querySelector('.quiz_result_text');
    resultText.innerHTML = `<span class="cname"> ${fnameVal}</span>, here are your results! `;
     
    document.getElementById('waitingTxt_M').style.display = 'none';

    // await sleep(1500);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.getElementById("resultsStepM").classList.add("modal-bg");
    document.body.classList.add("overflow-hidden");
    if(mobileTutorial != null){
      mobileTutorial.style.opacity = 1;
    }
  }


  var timerOne,timerTwo;
  function FakeLoading(){

    document.getElementsByClassName("loading-bar")[0].style.display = "block";
    document.getElementsByClassName("loading-bar")[1].style.display = "block";   

    const progressBar = document.querySelector('.progress');
    const progressBar2 = document.querySelector('.progress2');
    const loadingText = document.getElementById('loading-text');
    const loadingText2 = document.getElementById('loading-text2');
    let progress = 0;
    
    timerOne = setInterval(() => {
      if (progress >= 0) {
        loadingText.innerText = 'Please wait...';
        clearInterval(timerOne);
        setTimeout(() => {
          timerOne = setInterval(() => {
            if (progress >= 30) {
              loadingText.innerText = 'We are calculating your chart';
              clearInterval(timerOne);
              setTimeout(() => {
                timerOne = setInterval(() => {
                  if (progress >= 60) {
                    loadingText.innerText = 'Preparing the results';
                    clearInterval(timerOne);
                  } else {
                    progress++;
                    progressBar.style.width = progress + '%';
                  }
                }, 10);
              }, 1000);
            } else {
              progress++;
              progressBar.style.width = progress + '%';
            }
          }, 10);
        }, 1000);
      } else {
        progress++;
        progressBar.style.width = progress + '%';
      }
    }, 10);
    

    timerTwo = setInterval(() => {
      if (progress >= 0) {
        loadingText2.innerText = 'Please wait...';
        clearInterval(timerTwo);
        setTimeout(() => {
          timerTwo = setInterval(() => {
            if (progress >= 30) {
              loadingText2.innerText = 'We are calculating your chart';
              clearInterval(timerTwo);
              setTimeout(() => {
                timerTwo = setInterval(() => {
                  if (progress >= 60) {
                    loadingText2.innerText = 'Preparing the results';
                    clearInterval(timerTwo);
                  } else {
                    progress++;
                    progressBar2.style.width = progress + '%';
                  }
                }, 10);
              }, 1000);
            } else {
              progress++;
              progressBar2.style.width = progress + '%';
            }
          }, 10);
        }, 1000);
      } else {
        progress++;
        progressBar2.style.width = progress + '%';
      }
    }, 10);

  }


  function completeLoading() {
  const progressBar = document.querySelector('.progress');
  const loadingText = document.getElementById('loading-text');

  const progressBar2 = document.querySelector('.progress2');
  const loadingText2 = document.getElementById('loading-text2');

  let progress = Number(progressBar.style.width.replace('%', ''));
  clearInterval(timerOne); // Stop any ongoing loading
  loadingText.innerText = 'Done!';
  const intervalId = setInterval(() => {
    if (progress >= 100) {
      clearInterval(intervalId);
    } else {
      progress++;
      progressBar.style.width = progress + '%';
    }
  }, 10);


  let progress2 = Number(progressBar2.style.width.replace('%', ''));
  clearInterval(timerTwo); // Stop any ongoing loading
  loadingText2.innerText = 'Done!';
  const intervalId2 = setInterval(() => {
    if (progress2 >= 100) {
      clearInterval(intervalId2);
    } else {
      progress2++;
      progressBar2.style.width = progress2 + '%';
    }
  }, 10);


}
  

  const sleep = async (milliseconds) => {
    await new Promise(resolve => {
        return setTimeout(resolve, milliseconds)
    });
};
// new api task
async function AstroApi(name,gender,place,day,month,year,hour,min,long,lat) {

  var offsetToUse = await fethTimeZoneOffset(lat, long);
  offsetToUse--;
  // console.log("offset is:new " + offsetToUse + typeof offsetToUse);
  var timezone = parseInt(offsetToUse);
  // console.log(timezone,"timezone----------");
  
  // accesstoken api
  let accessToken ;
  fetch('https://api.bloom.be/api/auth', {
      method: 'POST',
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          "email": "hello@shoptenthhouse.com",
          "password": "ojSAgWjhfIrkotga"
      })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // console.log('Success:', data);
        accessToken = data.accessToken
        // console.log('accessToken---inside',typeof accessToken, accessToken);
    })
    .catch(error => {
        console.error('Error:', error);
    });

    setTimeout(function (params) {
      //  console.log('accessToken----', accessToken);
      // console.log(place,"place---");
      // console.log(place.toString().split('  ')[0],"place---split");
      
      let city = place.toString().split('  ')[0];
        let place_id ;

         fetch('https://api.bloom.be/api/places', {
          method: 'POST',
          headers: {
             'Accept-Encoding':'application/json',
             'Content-Type': 'application/json',
             'Authorization':'Bearer '+accessToken+''
          },
          body: JSON.stringify({
             "name": ''+city+'',
          })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            // console.log('Success:------place', data);
            place_id = parseInt(data.data[0].id);
            // console.log('place_id---inside',typeof place_id, place_id);
        })
        .catch(error => {
            console.error('Error:', error);
        });

      setTimeout(function (params) {
        
      // console.log('place_id---',typeof place_id, place_id);
      // planets data api
       fetch('https://api.bloom.be/api/natal', {
        method: 'POST',
        headers: {
          'Accept-Encoding':'application/json',
          'Content-Type': 'application/json',
          'Authorization':'Bearer '+accessToken+''
        },
         body: JSON.stringify({
              "name": ''+name+'',
              "date": ''+year+'-'+month+'-'+day+'',
              "time": ''+ hour+':'+min+'',
              "place_id": place_id,
              "lang": "en",
              "system": "W",
              "planets": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
              "collect_text": true
          })
      })
       .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(data => {
          // console.log('Success:---finaldata----W', data);
          planets = data.planets;
          // console.log(planets,"planetsNew---------"); 
        
          rising = data.ascendant.signId + 1;
          // console.log("RISING IS " + rising);
          // console.log("RISING name---" + data.ascendant.signName);
          GetPlanetsIndexes();
        
      })
      .catch(error => {
          console.error('Error:', error);
      });
        },2000);

  },2000);
}